// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pq-0";
export var animationContainer = "_pq-1";
export var itemPrice = "_pq-a";
export var itemizedContent = "_pq-9";
export var itemizedHeader = "_pq-7";
export var itemizedRow = "_pq-8";
export var itemizedSection = "_pq-6";
export var modalContent = "_pq-2";
export var orderName = "_pq-3";
export var refundOption = "_pq-4";
export var refundOptionsContainer = "_pq-5";
export var shippingLabel = "_pq-b";
export var totalRow = "_pq-c";